import React, { useState, useEffect, useRef } from "react";
import { Modal, Form, Input, Button, Upload } from "antd";
import { firestore, storage } from "../../config/firebase";
import { v4 as uuidv4 } from "uuid";
import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import {
  collection,
  addDoc,
  updateDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";
import { UploadOutlined } from "@ant-design/icons";

const PostModal = ({ isOpen, onClose, selectedPost }) => {
  const [form] = Form.useForm();
  const [selectedImages, setSelectedImages] = useState([]);
  const [nextImage, setNexImages] = useState([]);
  useEffect(() => {
    form.resetFields();
    if (selectedPost) {
      form.setFieldsValue({
        title: selectedPost.title,
        content: selectedPost.content,
      });
      setSelectedImages(selectedPost.images);
    } else {
      setSelectedImages([]);
    }
  }, [selectedPost]);

  const handleSave = async () => {
    let imageUrl;
    try {
      const values = await form.validateFields();
      const post = {
        title: values.title,
        content: values.content,
      };
      let arr = nextImage.filter((el) => {
        let ext = el.name.split(".");
        if (ext[1] == "svg") return el;
      });
      if (arr?.length > 0) {
        form.setFields([
          {
            name: "image", // required
            errors: ["SVG images are not allowed"],
          },
        ]);
        return;
      }
      let errors = form.getFieldsError();
      errors = errors
        ?.filter((el) => el?.errors?.length > 0)
        .map((el) => el?.errors[0]);
      console.log("Error list========", errors);
      if (errors.length > 0) return;

      imageUrl = await Promise.all(
        nextImage.map(async (image) => {
          const uniqueFilename = `${Date.now()}-${uuidv4()}`;
          const storageRef = ref(storage, `postImages/${uniqueFilename}`);
          await uploadBytes(storageRef, image);
          return getDownloadURL(storageRef);
        })
      );
      
      selectedImages?.length > 0
        ? (post.images = [...selectedImages, ...imageUrl])
        : (post.images = [...imageUrl]);

      await updateDoc(
        doc(collection(firestore, "posts"), selectedPost.id),
        post
      );

      onClose();
      window.location.reload();
    } catch (error) {
      console.error("Error saving post:", error);
    }
  };

  const handleImageChange = async (info) => {
    const { fileList } = info;
    const uploadedImages = fileList.map((file) => file.originFileObj);
    let arr = uploadedImages.filter((el) => {
      let ext = el.name.split(".");
      if (ext[1] == "svg") return el;
    });
    if (arr?.length > 0) {
      form.setFields([
        {
          name: "image", // required
          errors: ["SVG images are not allowed"],
        },
      ]);
      return;
    }
    else  form.setFields([
      {
        name: "image", // required
        errors: [],
      },
    ]);
    setNexImages([...uploadedImages]);
    // setSelectedImages([...uploadedImages])
    // if (uploadedImages.length > 0) {
    //   try {
    //     const newImageUrls = await Promise.all(
    //       uploadedImages.map(async (image) => {
    //         const uniqueFilename = `${Date.now()}-${uuidv4()}`;
    //         const storageRef = ref(storage, `postImages/${uniqueFilename}`);
    //         await uploadBytes(storageRef, image);
    //         return getDownloadURL(storageRef);
    //       })
    //     );

    //     setSelectedImages((prevImages) => [...prevImages, ...newImageUrls]);
    //   } catch (error) {
    //     console.error("Error uploading images:", error);
    //   }
    // }
  };

  const handleRemoveImage = (indexToRemove) => {
    setSelectedImages((prevImages) =>
      prevImages.filter((image, index) => index !== indexToRemove)
    );
  };
  return (
    <Modal
      title={selectedPost ? "Edit Post" : "Create Post"}
      open={isOpen}
      onCancel={onClose}
      footer={null}
    >
      <Form form={form} onFinish={handleSave}>
        <Form.Item
          label="Title"
          name="title"
          rules={[
            { required: true, message: "Title is required" },
            { min: 3, message: "Minimum 3 characters required" },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Content"
          name="content"
          rules={[{ min: 20, message: "Minimum 20 characters required" }]}
        >
          <Input.TextArea />
        </Form.Item>

        <Form.Item label="Images" name={"image"}>
          <Upload
            onChange={handleImageChange}
            beforeUpload={() => false}
            multiple
          >
            <Button icon={<UploadOutlined />}>Upload Images</Button>
          </Upload>
        </Form.Item>
        <div style={{ marginTop: "16px" }}>
          {selectedImages?.map((imageUrl, index) => (
            <div key={index}>
              <img
                src={imageUrl}
                alt={`Uploaded Image ${index}`}
                style={{ width: "100px", height: "100px", marginRight: "8px" }}
              />
              <Button type="link" onClick={() => handleRemoveImage(index)}>
                Remove
              </Button>
            </div>
          ))}
        </div>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PostModal;
